import axios from 'axios'
import {toast} from 'react-toastify'
import {apiUrl} from './constantVariables'

class RestApiData {
  apiUrl: string | undefined
  constructor() {}
  async restApi(method: string, url: string, data: any) {
    const adminData = localStorage.getItem('admin')
    if (!adminData) {
      throw new Error('Not authenticated')
    }
    let tokenStr = ''
    try {
      const token = JSON.parse(adminData) as {JWToken?: string; token?: string}
      tokenStr = token.JWToken || token.token || ''
    } catch {
      throw new Error('Invalid admin session')
    }
    if (!tokenStr) {
      throw new Error('Missing admin token')
    }

    try {
      const request: any = {
        method,
        url: url,
        headers: {'x-access-token': tokenStr},
      }
      const methodLower = method.toLowerCase()
      if (methodLower !== 'get' && methodLower !== 'delete' && data !== '' && data != null) {
        request.data = data
      }
      const response = await axios(request)
      // toast.success(response?.data.message);
      return response
    } catch (error: any) {
      if (error) {
        console.error('Response Data :->', error.message)
        toast.error(error.message)
      }

      if (error.response?.statusText === 'Bad Request' && error.response.status === 400) {
        // window.location.href = "/auth";
      } else {
        throw error
      }
    }
  }

  // async adminLogin(data: any) {
  //   return this.restApi('post', `${apiUrl}/admin/login`, data)
  // }

  async getDashboardData() {
    return this.restApi('get', `${apiUrl}/admin/dashboard`, '')
  }

  async getDashboardAllData(filter: any) {
    const params = new URLSearchParams()
    if (typeof filter === 'string') {
      params.set('month', filter)
    } else if (filter?.all_time) {
      params.set('all_time', 'true')
    } else {
      if (filter?.month) params.set('month', String(filter.month))
      if (filter?.date_from) params.set('date_from', String(filter.date_from))
      if (filter?.date_to) params.set('date_to', String(filter.date_to))
    }
    return this.restApi('get', `${apiUrl}/admin/getAllData?${params.toString()}`, '')
  }

  async getUsersManagementList(data: any) {
    return this.restApi('post', `${apiUrl}/admin/all_users`, data)
  }

  async updateUserStatus(data: any) {
    return this.restApi('post', `${apiUrl}/admin/user/active`, data)
  }

  //User Details View

  async getUserData(id: any) {
    return this.restApi('get', `${apiUrl}/admin/get_user?user_id=${id}`, '')
  }

  async getCarThresholdData(id: any) {
    return this.restApi('get', `${apiUrl}/admin/get_user_car_threshold?user_id=${id}`, '')
  }

  async getUserTripData(id: any) {
    return this.restApi('get', `${apiUrl}/admin/user_trips?user_id=${id}`, '')
  }

  async getUserMatesData(id: any) {
    return this.restApi('get', `${apiUrl}/admin/user_mates?user_id=${id}`, '')
  }

  async getUserTripsList(userId: any, page: number) {
    return this.restApi(
      'get',
      `${apiUrl}/admin/user_trips/list?user_id=${userId}&page=${page}`,
      ''
    )
  }

  async getRevenueData(month: string) {
    return this.restApi('get', `${apiUrl}/admin/revenue?month=${month}`, '')
  }

  async getRetentionData(month: string) {
    return this.restApi('get', `${apiUrl}/admin/retention?month=${month}`, '')
  }

  async getBusinessMatrixData(month: string) {
    return this.restApi('get', `${apiUrl}/admin/business-matrix?month=${month}`, '')
  }

  async deleteUserData(id: any) {
    return this.restApi('delete', `${apiUrl}/admin/user?user_id=${id}`, '')
  }

  async getSettingsData() {
    return this.restApi('get', `${apiUrl}/settings`, '')
  }

  // Update Price Value
  async updatedPriceValue(data: any) {
    return this.restApi('post', `${apiUrl}/settings/app_price_suggest_value`, data)
  }

  // Get Trip Data
  async getTripsData(data: any) {
    return this.restApi('post', `${apiUrl}/admin/trips`, data)
  }

  // Get Gift Card

  async getGiftCardData(data: any) {
    return this.restApi('post', `${apiUrl}/admin/giftCard`, data)
  }

  async getGiftCardDetail(id: string | number) {
    return this.restApi(
      'get',
      `${apiUrl}/admin/giftCard/detail?redemptionId=${encodeURIComponent(String(id))}`,
      null
    )
  }

  // Get All categories in gift card filter (admin — not mobile /api/gift-card)
  async getGiftFilterCategories() {
    return this.restApi('get', `${apiUrl}/admin/giftCard/categories`, '')
  }

  async getMatesData(page: number, search: string) {
    return this.restApi('get', `${apiUrl}/admin/mates?page=${page}&search=${search}`, '')
  }

  // Get Wallets Data
  async getWalletsData(data: any) {
    return this.restApi('post', `${apiUrl}/admin/wallet`, data)
  }

  //Get Payment Data
  async getPaymentsData(data: any) {
    return this.restApi('post', `${apiUrl}/admin/payment`, data)
  }

  async getPaymentTransactionTypes() {
    return this.restApi('get', `${apiUrl}/admin/payment/types`, '')
  }

  async getPaymentDetail(paymentId: string | number) {
    return this.restApi('get', `${apiUrl}/admin/payment/detail?paymentId=${paymentId}`, '')
  }

  //Trip Details Data
  async getTripDetailData(id: any) {
    return this.restApi('get', `${apiUrl}/admin/trip/detail?tripId=${id}`, '')
  }

  // Get Feedbacks Data
  async getFeedbackAllData(data: any) {
    return this.restApi('post', `${apiUrl}/admin/feedbacks`, data)
  }

  // Get Feedback Detail Data
  async getFeedbackDetailData(id: any) {
    return this.restApi('get', `${apiUrl}/admin/feedback/detail?feedbackId=${id}`, '')
  }

  // Export Report
  // async exportReportData(data: any) {
  //   return this.restApi('post', `${apiUrl}/admin/report`, data)
  // }
}

export const restRequest = new RestApiData()
